module.exports = __webpack_public_path__ + "img/logo2.90bdc577.png";